import { Component } from "react";
import Layout from "../../componentes/Comunes/Layout/Layout";
import servicioUsuario from "../../servicios/servicioUsuario";

class PerfilUsuario extends Component {
  state = { usuario: null };

  async componentDidMount() {
    const usuario = await servicioUsuario.obtenerUsuarioDelSistema();
    this.setState({ usuario });
  }

  render() {
    const { usuario } = this.state;

    return (
      <Layout>
        <div className="d-sm-flex align-items-center justify-content-between mb-2">
          <h1 className="h3 mb-0 text-gray-800">Perfil de Usuario</h1>
        </div>
        <p className="mb-4 pl-3 border-left-warning">
          Si algún dato está incorrecto o necesita permisos adicionales, por
          favor contacte a un usuario administrador del sistema{" "}
          <span className="font-weight-bold">Usuarios Externos</span> de su
          entidad.
        </p>
        <div className="row">
          <div className="col-md-8">
            <div className="card shadow mb-4">
              <div className="card-header">
                <h6 className="m-0 font-weight-bold text-primary">
                  Información General
                </h6>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-sm-3">
                    <p className="mb-0">Identificación</p>
                  </div>
                  <div className="col-sm-9">
                    <p className="text-muted mb-0">{usuario?.identificacion}</p>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-sm-3">
                    <p className="mb-0">Nombre Completo</p>
                  </div>
                  <div className="col-sm-9">
                    <p className="text-muted mb-0">
                      {usuario?.persona.nombreCompleto}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-sm-3">
                    <p className="mb-0">Nombre de Usuario</p>
                  </div>
                  <div className="col-sm-9">
                    <p className="text-muted mb-0">{usuario?.nombreUsuario}</p>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-sm-3">
                    <p className="mb-0">Correo Electrónico</p>
                  </div>
                  <div className="col-sm-9">
                    <p className="text-muted mb-0">
                      {usuario?.correoElectronico}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-sm-3">
                    <p className="mb-0">Teléfono</p>
                  </div>
                  <div className="col-sm-9">
                    <p className="text-muted mb-0">{usuario?.telefono}</p>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-sm-3">
                    <p className="mb-0">Entidad</p>
                  </div>
                  <div className="col-sm-9">
                    <p className="text-muted mb-0">{usuario?.entidad.alias}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card shadow mb-4">
              <div className="card-header">
                <h6 className="m-0 font-weight-bold text-primary">Permisos</h6>
              </div>
              <div className="list-group list-group-flush">
                {usuario?.roles.map((rol) => (
                  <li
                    key={rol}
                    className="list-group-item"
                    style={{ marginBottom: 0 }}
                  >
                    {rol}
                  </li>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

export default PerfilUsuario;
